import { IonIcon } from '@ionic/react'
import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import { flashOutline } from 'ionicons/icons'

/** Power-lines-on-site safety banner (v1). */
export const LinesOnSiteCallout = ({
  linesOnSite,
}: {
  linesOnSite: boolean | null | undefined
}) => {
  const { _ } = useLingui()
  if (!linesOnSite) return null
  return (
    <div className='order-detail__lines-callout'>
      <IonIcon icon={flashOutline} />
      {_(msg`Lines on Site`)}
    </div>
  )
}
